/**
 * EVO — kirish nuqtasi.
 *
 * Provayderlar tartibi muhim:
 *   I18nProvider  → matnlar hamma joyda kerak (xato xabarlari ham)
 *   QueryProvider → so'rovlar
 *   AuthProvider  → so'rov qiladi (`/auth/me`), shuning uchun Query ichida
 *   RouterProvider→ marshrutlar auth holatiga qaraydi, shuning uchun eng ichkarida
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ApiError } from './lib/api';
import { AuthProvider } from './lib/auth';
import { ActiveBranchProvider } from './components/layout/branch-switcher';
import { I18nProvider } from './lib/i18n-context';
import { initTheme } from './lib/theme';
import { router } from './routes';
import './styles.css';

/*
 * Mavzu React'dan OLDIN qo'yiladi — birinchi kadr allaqachon to'g'ri rangda
 * chiziladi. `useEffect` ichida qilinsa ekran oqdan qorong'iga sakrardi.
 */
initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ERP ma'lumoti tez eskiradi (qoldiq, qarz), lekin har fokusda
      // 20 ta so'rov yuborish ham ortiqcha — 30 soniya muvozanat.
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // 4xx ni qayta urinish ma'nosiz: ruxsat yo'q bo'lsa keyin ham bo'lmaydi.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        // Tarmoq uzilishi — O'zbekistonda odatiy hol (GAP_ANALYSIS §C1),
        // shuning uchun 2 marta qayta urinamiz.
        return failureCount < 2;
      },
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root elementi topilmadi');
}

createRoot(rootElement).render(
  <StrictMode>
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          {/*
            `ActiveBranchProvider` AUTH ICHIDA: u `/org/branches` ni so'raydi
            va so'rov faqat kirilgan foydalanuvchida ma'noga ega. Tashqarida
            tursa, login ekranida 401 so'rov ketardi va u jurnalni bekorga
            to'ldirardi.
          */}
          <ActiveBranchProvider>
            <RouterProvider router={router} />
          </ActiveBranchProvider>
        </AuthProvider>
      </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
);
